import { createFileRoute, redirect } from '@tanstack/react-router';

/** @note 未実装のため業務イベント一覧にリダイレクト */
export const Route = createFileRoute(
  '/_staff/business-operation-events/_list/operation-activity',
)({
  beforeLoad: () => {
    throw redirect({ to: '/business-operation-events' });
  },
});
